
import React from 'react';
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { BookingLink } from '@/types/booking';
import { Check } from 'lucide-react';

interface PaymentSummaryProps {
  serviceDetails?: BookingLink['serviceDetails'];
  paymentRequired: boolean;
  amount: number;
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  serviceDetails,
  paymentRequired,
  amount
}) => {
  if (!paymentRequired || amount <= 0) return null;

  return (
    <Card className="p-6 mb-6">
      <h3 className="text-lg font-medium mb-4">Payment Receipt</h3>
      
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span>{serviceDetails?.name || 'Consultation'}</span>
          <span>${amount.toFixed(2)}</span>
        </div>
        
        {/* Add tax or other fees here if needed */}
        
        <Separator className="my-2" />
        
        <div className="flex justify-between items-center font-medium">
          <span>Total</span>
          <span>${amount.toFixed(2)}</span>
        </div>

        <div className="flex items-center text-green-600 bg-green-50 p-3 rounded-md">
          <Check className="h-5 w-5 mr-2" />
          <p className="text-sm font-medium">Payment Successful</p>
        </div>
        
        {serviceDetails?.cancellationPolicy && (
          <div className="mt-3">
            <p className="text-sm font-medium">Cancellation Policy:</p>
            <p className="text-xs text-muted-foreground">{serviceDetails.cancellationPolicy}</p>
          </div>
        )}
        
        <p className="text-xs text-muted-foreground mt-2">
          A receipt has been sent to your email address.
        </p>
      </div>
    </Card>
  );
};

export default PaymentSummary;
